import React from "react";
import Header from "../home/header";
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import StaffItem from "./staff_item";
import { ApiClient } from "../../utils/api-client";
import { Fragment } from "react";
import Loading from "../home/Loading";
import PaginationControl from "../home/pagination_control";
import { AxiosError } from "axios";
import UTILS from "../../utils/commons";


const Staff = ( props ) => {
    let navigate = useNavigate();
    let location = useLocation();
    var loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
    const [ staffMembers, setStaffMembers ] = useState( [] );
    const [ filteredStaffMembers, setFilteredStaffMembers ] = useState( staffMembers );
    const [ loading, setLoading ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ pageSize, setPageSize ] = useState( 10 );
    const [ totalPages, setTotalPages ] = useState( Math.ceil( filteredStaffMembers.length / pageSize ) );
    const [ hasNextPage, setHasNextPage ] = useState( false );
    const [ hasPreviousPage, setHasPreviousPage ] = useState( false );

    const handlePageChange = ( newPage ) => {
        setCurrentPage( newPage );
        loadStaff( newPage, pageSize );
    }
    const handlePageSizeChange = ( newPageSize ) => {
        setPageSize( newPageSize );
        setCurrentPage( 1 );
        loadStaff( 1, newPageSize );
    }
    const loadStaff = async ( page, pageSize ) => {
        setLoading( true );
        try {
            const response = await apiClient.get( "/profiles", {
                params: {
                    page: page,
                    limit: pageSize
                }
            } );
            setStaffMembers( response.data.data );
            setFilteredStaffMembers( response.data.data );
            setCurrentPage( response.data.page );
            setTotalPages( Math.ceil( response.data.total / pageSize ) );
            setHasNextPage( response.data.hasNextPage );
            setHasPreviousPage( response.data.hasPreviousPage );
            setLoading( false );
        }
        catch ( e ) {
            console.log( "Error fetching staff", e );
            setLoading( false );
            if ( e instanceof AxiosError && e.status === 401 ) {
                UTILS.signout();
                navigate( '/signin', { replace: true, target: '/staff' } );
            }
        }
    }
    useEffect( () => {
        loadStaff( 1, pageSize );
    }, [ pageSize ] );
    const confirmDelete = ( itemId ) => {
        let message = "Are you sure you want to delete this staff account?";
        if ( window.confirm( message ) ) {

            // deleteStaff( itemId )
        }

    }
    const deleteStaff = ( pid ) => {
        //
    }

    return ( <>
        <Header auth={loginState} />
        <section className="flex justify-start items-start">
            <div className="container">
                <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div>
                            <p className="text-sm uppercase tracking-wide text-gray-500">Team</p>
                            <p className="text-2xl font-semibold text-gray-800">Staff</p>
                        </div>
                        <div className="w-full md:w-auto flex flex-col md:flex-row gap-3">
                            <input className="w-full md:w-80 px-3 py-2 focus:outline-none rounded-md border border-gray-300 focus:ring-2 focus:ring-gray-300" type="text" placeholder="Search staff..." onChange={( e ) => {
                                let keyword = e.target.value.toLowerCase();
                                let filteredResults = staffMembers.filter( p =>
                                    ( p?.auth?.firstName || '' ).toLowerCase().includes( keyword ) ||
                                    ( p?.auth?.lastName || '' ).toLowerCase().includes( keyword ) ||
                                    ( p?.department || '' ).toLowerCase().includes( keyword )
                                );
                                setFilteredStaffMembers( filteredResults );
                            }} />
                            <button className="btn bg-success md:min-w-[7rem]" onClick={() => navigate( "/staff/new", { replace: false } )}>Add Staff</button>
                        </div>
                    </div>
                </div>
                {loading ? ( <Loading className="mx-auto mt-16" /> ) : (
                    <div className="mt-12">{filteredStaffMembers.length > 0 ? <PaginationControl pageSize={pageSize} currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} /> : null}
                        <div className="border border-gray-200 rounded-lg overflow-hidden pt-0 grid md:grid-cols-1 gap-0 md:justify-start md:items-center flex-wrap" id="list_container">
                            {filteredStaffMembers && filteredStaffMembers.length > 0 ? filteredStaffMembers.map( r => {
                                return <StaffItem data={r} key={r.id} onDelete={() => confirmDelete( r.id )} onClick={() => { navigate( "/staff/view/" + r.id, { replace: false, state: r } ) }} onEdit={() => { navigate( "/staff/edit/" + r.id, { replace: false, state: r } ) }} />
                            } ) : <span className="text-start w-full py-8 px-4 text-gray-500">No data</span>
                            }
                        </div>
                    </div>
                )}</div>
        </section>
    </> )

}
export default Staff;